import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
}
export function Button({
  children,
  className = '',
  ...props
}: ButtonProps) {
  return <button className={`bg-coral hover:bg-[#b0603d] text-white font-medium py-4 px-8 rounded-full transition-colors duration-300 shadow-sm hover:shadow-md text-lg w-full sm:w-auto ${className}`} {...props} data-id="element-30">
      {children}
    </button>;
}